/* eslint-disable sort-keys-fix/sort-keys-fix */
export default {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
};
